<template>
    <div class="page white_bg">

        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader paddingH16 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px"></div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <div class="flexLayout marginB20" style="padding: 14px 18px 0;" v-if="userInstance" :data-userid="userInstance ? userInstance.id : ''">
                <div style="width: 80px;">
                    <div class="imageArea circle hiddenOverflow" style="height: 80px; border: solid 1px #BBBBBB;"
                         :data-headerImg="userInstance ? userInstance.headerImg : ''">
                        <img class="fullSpace cover" :src="userInstance.headerImg" v-if="userInstance && userInstance.headerImg"/>
                    </div>
                </div>
                <div class="marginL16 flexItem">

                    <div class="font12r" style="padding-top:  12px;">
                        {{ userInstance ? userInstance.userName : '' }}
                        <span class="textLabel vipLabel marginL4">园所精品课尊享</span>
                    </div>

                    <div class="font12r marginT16 grey">
                        有效期：
                        {{ userInstance && userInstance.vipInfoMap.course_vod.status ?
                            userInstance.vipInfoMap.course_vod.dueTime : '未开通' }}
                    </div>
                    <!--                <div class="font14r marginT16">-->
                    <!--                    过期日期：{{ userInfo ? formatDate(userInfo.expireTime) : '' }}-->
                    <!--                </div>-->
                </div>
            </div>

            <div v-if="content">
                <article class="article" v-html="content"></article>
            </div>

            <div style="height: 60px;"></div>
        </div><!-- end .body -->

        <div class="fixedBottom bgWhite paddingB24">
            <div class="paddingV4 paddingH16">
                <button class="submitButton" type="button" @click="$refs.noticeForOpenPrivilegeDrawer.show()">联系教务协助开通子账号</button>
            </div>
        </div>

        <noticeForOpenPrivilegeDrawer ref="noticeForOpenPrivilegeDrawer"/>
    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import noticeForOpenPrivilegeDrawer from "./noticeForOpenPrivilegeDrawer";

import vipApi from '@/api/vip';
import aboutApi from '@/api/about';
import bizTypeEnum from "@data/bizTypeEnum";
import appHelper from "@util/appHelper";
import consoleHelper from "@util/consoleHelper";
import userUtil from "@comp/shixunApp/userUtil";
import favoriteApi from "@api/favorite";

const config = {
    name : 'courseVipPersonalCenter',
    title : '园所精品课尊享中心',
    description : ''
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { noticeForOpenPrivilegeDrawer },
    data () {
        return {
            title : config.title,
            description : config.description,
            // VIP 介绍
            vipEnjoyData : null,
            // VIP 套餐数组
            vipInfo : null,

            // VIP 一年套餐信息
            vipPackage : null,

            content: '',

            userInstance : null
        }
    },
    methods : {
        /**
         * @method  getVipPurchaseYearPackage
         * @param   {String}  type
         * @returns {null|Object}
         */
        getVipPurchaseYearPackage(type = 'super') {

            let vipPurchaseYearList = this.vipPurchasePackages[type];
            for (let i=0; i<vipPurchaseYearList.length; i++)
            {
                if (vipPurchaseYearList[i].timeType === 'year')
                {
                    return vipPurchaseYearList[i];
                }
            }

            return null;
        },

        // 购买会员
        buy() {
            let yearPackage = this.vipPackage;
            this.$refs.generalPayDialog.setProduct({
                id : yearPackage.dbValue,
                title : yearPackage.title,
                price : yearPackage.price,
                bizType : bizTypeEnum.VIP.code
            });
            this.$refs.generalPayDialog.open();
        },

        onPaySuccess : function (result) {
            // let orderId = result.orderId || '';
            appHelper.goToPage('openSuccessForCourseVip');
        },
    },
    mounted() {
        const me = this;

        appHelper.checkLogin((error, userData) => {

            if (error) {
                return;
            }

            consoleHelper.logDebug('user base info:');
            consoleHelper.logDebug('user name: ' + userData ? userData.userName : '游客');
            if (userData) {
                me.userInstance = userUtil.createUser(userData);
                me.userInstance.getVipInfo();
            }

            me.setWechatShare();

            if (!userData) {    // 游客
                return;
            }
        });

        vipApi.loadVipEnjoyInfo(2, (result) => {
            me.vipEnjoyData = result.data;
        });

        vipApi.loadVipInfo(2, (result) => {
            me.vipInfo = result.data;

            for (let i=0; i<me.vipInfo.length; i++){
                if (me.vipInfo[i].timeType == 'year')
                {
                    me.vipPackage = me.vipInfo[i];
                }
            }
        });

        aboutApi.getResource('COURSE_VIP_DETAIL', (result) => {
            me.content = result;
        });
    }
}
</script>

<style lang="scss" scoped>
.grey {
    color: #ADAAAA;
}
.submitButton {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    border: none;
    background-color: rgba(56, 162, 138, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
}
.vipLabel {
    height: 27px;
    line-height: 27px;
    border: solid 1px #588EE2;
    color: #588EE2;
    background: transparent;
    padding: 0 4px;
    font-size: 14px;
}
</style>
